export default {
      id: "weather__weather-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.svg#weather__weather",
      toString: function () {
        return this.url;
      }
    }